module.exports = __webpack_public_path__ + "static/media/nopic.41b58f24.jpg";